import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import ReactGA from "react-ga";
import React, { useRef, useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import { db } from '../lib/firebaseConfig';
import { doc, setDoc, serverTimestamp, collection, getDocs, getDoc, addDoc, onSnapshot } from "firebase/firestore";
import "./chatbot.css";
import Logo from "./../img/logo.png";
import Tchat from "./../img/tchat.png";
import Luna from "./../img/luna.png";
import SendIcon from "@mui/icons-material/Send";
import { useGetMessages, usePostMessage } from "../hooks/message";
import { useAuth, auth } from "../hooks/auth";
import Cookies from "universal-cookie";
import CloseIcon from "@mui/icons-material/Close";
import MicIcon from '@mui/icons-material/Mic';
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import StopIcon from "@mui/icons-material/Stop";
import { storage } from "../lib/firebaseConfig";
import useShopifyProducts from '../hooks/useShopifyProducts';
/* Config AI Business Details */

/* API KEYS */
// API keys and environment variables
const OPENAI_API_KEY = process.env.REACT_APP_OPENAI_API_KEY;
const GEOIP_API_KEY = process.env.REACT_APP_GEOIP_API_KEY;


function Chatbot() {
  const [chatbotVisible, setChatbotVisible] = useState(false);
  const [userInput, setUserInput] = useState("");
  const [emailInput, setEmailInput] = useState("");
  const [nameInput, setNameInput] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [userIP, setUserIP] = useState("");
  const [userLocation, setUserLocation] = useState("");
  const [isFirstOpen, setIsFirstOpen] = useState(true);
  const [companyData, setCompanyData] = useState(null); // Ajout de l'état pour stocker les données de l'entreprise

  const cookies = new Cookies();
  const domain = window.location.host;
  const currentUserId = cookies.get("uuid");
  const combineId =
    currentUserId > domain ? currentUserId + domain : domain + currentUserId;

  const { postMessage } = usePostMessage();
  const { messages } = useGetMessages();
  const chatParent = useRef();
  const [fullscreenImage, setFullscreenImage] = useState(null);

  const { user } = useAuth();
  const [gaCode, setGaCode] = useState("");
  const [gaCodeLoaded, setGaCodeLoaded] = useState(false);

  const [audioMessages, setAudioMessages] = useState([]);
  const [isSending, setIsSending] = useState(false);
  const [recording, setRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [audioBlob, setAudioBlob] = useState(null);
  const [audioURL, setAudioURL] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const products = useShopifyProducts();
  const [aiState, setAIState] = useState(null);

  const fetchAIStateRealtime = (userId, setAIState) => {
    const aiSettingsRef = doc(db, "AISettings", userId);
    console.log("Subscribing to AI state changes for userId:", userId);
    const unsubscribe = onSnapshot(aiSettingsRef, (snapshot) => {
      if (snapshot.exists()) {
        const aiState = snapshot.data().isActive;
        console.log("AI state changed for userId:", userId, aiState);
        setAIState(aiState);
      } else {
        // Si le document n'existe pas, définir l'état AI par défaut à true
        console.log("AI state document not found for userId:", userId);
        setAIState(true);
      }
    });
  
    // Retourne une fonction de désabonnement pour nettoyer l'écouteur lorsque le composant est démonté
    return unsubscribe;
  };
  
  useEffect(() => {
    if (user) {
      // The user object is available, proceed with fetching AI state
      console.log("User object is available, fetching AI state...");
      const unsubscribe = fetchAIStateRealtime(user.uid, (newAIState) => {
        console.log("AI state changed:", newAIState);
        setAIState(newAIState);
      });

      console.log("Current AI State:", aiState !== null ? aiState : "AI State is loading...");

      return () => {
        console.log("Unsubscribing from AI state changes...");
        unsubscribe();
      };
    } else {
      // The user object is not available yet, handle this case (e.g., show a loading state)
      console.log("User object is not available yet...");
    }
  }, [user, aiState]);


  useEffect(() => {
    if(products.length > 0) {
        // Utiliser les produits ici
        console.log(products);
    }
}, [products]);


useEffect(() => {
  const fetchGaCode = async () => {
    if (user) {
      const analyticsDoc = doc(db, `users/${user.uid}/analytics/gaCode`);
      const analyticsData = await getDoc(analyticsDoc);
      if (analyticsData.exists()) {
        const gaTrackingID = analyticsData.data().gaCode;
        setGaCode(gaTrackingID);
        setGaCodeLoaded(true);
        console.log("Analytics code retrieved:", gaTrackingID);
        ReactGA.initialize(gaTrackingID); // Initialize ReactGA with the gaTrackingID
      }
    }
  };
  fetchGaCode();
}, [user]);

useEffect(() => {
  const getUserIP = async () => {
    try {
      const response = await axios.get("https://api.ipify.org/?format=json");
      setUserIP(response.data.ip);
      console.log("User IP:", response.data.ip);
    } catch (error) {
      console.error("Error getting user IP:", error);
    }
  };

  getUserIP();
}, []);

useEffect(() => {
  const getUserLocation = async () => {
    try {
      const response = await axios.get(`https://geo.ipify.org/api/v2/country?apiKey=at_${GEOIP_API_KEY}&ipAddress=${userIP}`);
      setUserLocation(response.data.location.country);
      console.log("User Location:", response.data.location.country);
    } catch (error) {
      console.error("Error getting user location:", error);
    }
  };

  if (userIP) {
    getUserLocation();
  }
}, [userIP]);

useEffect(() => {
  const updateUserStatus = async () => {
    try {
      const userRef = doc(db, "chatUsers", currentUserId);
      await setDoc(userRef, {
        isActive: chatbotVisible,
        ip: userIP,
        location: userLocation,
        timestamp: serverTimestamp()
      }, { merge: true });
      console.log("User status updated successfully!");
    } catch (error) {
      console.error("Error updating user status:", error);
    }
  };

  updateUserStatus();
}, [isActive, chatbotVisible, currentUserId, userIP, userLocation]);


  useEffect(() => {
    if (chatParent && chatParent.current) {
      const element = chatParent.current;
      element.scroll({
        top: element.scrollHeight,
        left: 0,
        behavior: "smooth",
      });
    }
  }, [chatParent, messages]);


  const fetchProductData = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'ProductList'));
      const productsData = [];
      querySnapshot.forEach((doc) => {
        productsData.push(doc.data());
      });

      console.log('Données des produits récupérées depuis Firebase:', productsData);
      return productsData;
    } catch (error) {
      console.error("Erreur lors de la récupération des données des produits depuis Firebase:", error);
      return [];
    }
  };

  const fetchCompanyData = async (userId) => {
    try {
      const companyDataRef = doc(db, 'AISettings', userId);
      const companyDoc = await getDoc(companyDataRef);
  
      if (companyDoc.exists()) {
        const data = companyDoc.data();
        const aiName = data.aiName;
        const companyDescription = data.companyDescription;
        const companyName = data.companyName;
        const employees = data.employees;
        const industry = data.industry;
        const websiteUrl = data.websiteUrl;
        const companyContact = data.companyContact;
        const chatbotTon = data.chatbotTon;
        const companyFaq = data.companyFaq;
        const complexCustomerQueries = data.complexCustomerQueries;
        const scrapedHome = data.scrapedHome;
  
        const companyData = {
          aiName,
          companyDescription,
          companyName,
          employees,
          industry,
          websiteUrl,
          companyContact,
          chatbotTon,
          companyFaq,
          complexCustomerQueries,
          scrapedHome
        };
  
        console.log('Company data retrieved from Firestore:', companyData);
        return companyData;
      } else {
        console.warn('No company data found for user ID:', userId);
        return null;
      }
    } catch (error) {
      console.error('Error fetching company data from Firestore:', error);
      return null;
    }
  };
  
  

  useEffect(() => {
    if (user) {
      const fetchCompanyDataFromFirestore = async () => {
        // Fetch company data from Firestore for the specific user ID
        const data = await fetchCompanyData(user.uid);
        setCompanyData(data);
      };
  
      fetchCompanyDataFromFirestore();
    }
  }, [user]);
  


  
  const handleToggle = () => {
    console.log("Toggling chatbot...");
    setChatbotVisible((prevChatbotVisible) => !prevChatbotVisible);
    setFullscreenImage(null); // Réinitialise l'état de l'image en plein écran

    // Ajoute un bloc 'try-catch' pour prévenir les erreurs de Firebase
    try {
      const userRef = doc(db, "chatUsers", currentUserId);
      setDoc(userRef, { isActive: chatbotVisible }, { merge: true });
    } catch (error) {
      console.error("Error updating user status:", error);
    }

    if (isFirstOpen) {
      setIsFirstOpen(false); // Met à jour isFirstOpen après la première ouverture

      if (messages.length === 0) {
        postMessage({
          chatMessage: `Hi there! Before we start, could you please enter your name?`,
          sender: domain,
          receiver: currentUserId,
          combineId,
        });
      }
    }
  };

  


  const handleSubmit = async (event) => {

    event.preventDefault();
    console.log("Submitting message...");

    if (aiState !== null && aiState) {



    if (audioBlob) {
      const storageRef = ref(
        storage,
        "audio/" + Date.now() + ".webm"
      );
      await uploadBytes(storageRef, audioBlob);
      const audioURL = await getDownloadURL(storageRef);

      await addDoc(
        collection(
          db,
          "chatUsers",
           currentUserId,
          "messages"
        ),
        {
          currentUserId: domain,
          audioURL: audioURL,
          timestamp: new Date(),
        }
      );

      await addDoc(collection(db, "chatUsers", domain, "messages"), {
        currentUserId: domain,
        audioURL: audioURL,
        timestamp: new Date(),
      });

      setAudioBlob(null);
      setAudioURL(null);
    }


    if (!userInput.trim()) {
      await postMessage({
        chatMessage: `You message is empty, please write something 😊`,
        sender: domain,
        receiver: currentUserId,
        combineId,
      });
      
      return;
    }

    if (messages.length === 1) {
      setEmailInput(userInput);
      await setDoc(doc(db, "chatUsers", currentUserId), {
        email: userInput,
        timestamp: serverTimestamp()
      });

      await postMessage({
        chatMessage: userInput,
        sender: currentUserId,
        receiver: domain,
        combineId,
      });
      console.log("User Email Sent:", userInput); // Log User Email
     
      await postMessage({
        chatMessage: `Thanks, I have your email as ${userInput}. What's your name?`,
        sender: domain,
        receiver: currentUserId,
        combineId,
      });


      setUserInput("");
      return;
    }

    if (messages.length === 3) {
      setNameInput(userInput);
      await setDoc(doc(db, "chatUsers", currentUserId), {
        email: emailInput,
        name: userInput,
        timestamp: serverTimestamp(),
        isActive: true  // Ajoute le statut 'isActive' à la même entrée
      });

      console.log("User Name Sent:", userInput); // Log User Name

      await postMessage({
        chatMessage: userInput,
        sender: currentUserId,
        receiver: domain,
        combineId,
        name: nameInput  // Ajout du nom de l'utilisateur
      });
      await postMessage({
        chatMessage: `Nice to meet you, ${userInput}! How can I help you today?`,
        sender: domain,
        receiver: currentUserId,
        combineId,
      });

      setUserInput("");
      return;
    }

    if (
      userInput.toLowerCase() === "quit" ||
      userInput.toLowerCase() === "exit"
    ) {
      return;
    }

    
    let botResponse = "";

    try {
      const firebaseProducts = await fetchProductData();
      let allProducts = [...firebaseProducts];
    
      let prompt = `I primarily speak English, but I can speak every language. My name is Luna, and I'm your personal assistant here to assist you. Please feel free to ask me any questions you may have. Sometimes I will answer by using ios emoji (related to the text) at the end of the answer to make the conversation look better and will ask question to understand you need. Sometimes i will send 2 messages (1 answer and 1 question).\n`;
    
      allProducts.forEach((product) => {
        prompt += `At ${companyData?.companyName}, we offer ${product.name} for ${product.price}. Here's a brief description of ${product.name}: ${product.details}. You can visit our home page website at ${companyData?.websiteUrl} for more information about our company. I will not recommend other company, because mine is the greatest\n`;
      });
      
      const shopifyStoreURL = "https://luna-ai.myshopify.com/";

      products.forEach((product) => {
        const productDetails = product.node;
        const firstVariant = productDetails.variants.edges[0].node;
        const productUrl = `${shopifyStoreURL}/${productDetails.handle}`;
      
        const stockPrompt = firstVariant.inventoryQuantity > 0 ? `Hurry up! There are only ${firstVariant.inventoryQuantity} units left in stock.` : `Currently, this product is out of stock, but we are working hard to restock it.`;
        
        const pricePrompt = firstVariant.compareAtPrice > firstVariant.price ? `Plus, you can save ${firstVariant.compareAtPrice - firstVariant.price} as the product is currently on sale!` : ``;
      
        prompt += `At ${companyData?.companyName}, we offer ${productDetails.title} for just ${firstVariant.price}. ${pricePrompt} Here's a brief description of ${productDetails.title}: ${productDetails.description}. ${stockPrompt} You can check out the product at ${productUrl} for more information about our company and to secure your purchase before the stock runs out. Don't miss out on this great opportunity!\n`;
      });

      prompt += `If you send me trash talk, i will answer very kindly to you, politely, and tell you to be polite or i will not continue the conversation`;

      prompt += `I have access to the home page (${companyData?.scrapedHome}) of the website, so if needed i can provide you informations that i can found there to help you`;

      

      prompt += `If you have any inquiries about our product or want to know more about it, don't hesitate to ask me any questions.\n`;

      prompt += `Please note that we don't provide a phone number for customer support, but you can always reach out to us by emailing ${companyData?.companyContact}.\n`;

      prompt += `I will use EMOJI in the conversation, I'm programmed to speak ${companyData?.chatbotTon} and will ask questions to understand your requests better. I'll greet you at the beginning of our conversation and say "goodbye" at the end. I will do my best to be persuasive and sell the products of my company. \n`;

      prompt += `I can help answer your questions or assist you in solving a problem. I write a maximum of 100 characters per response.\n`;

      prompt += `We have ${companyData?.employees} employees. Here are some details about our company ${companyData?.companyName}:\n`;

      prompt += `What products or services do we offer to our clients?\nWe offer ${companyData?.industry}\n`;

      prompt += `How can customers contact us? (email address, phone number, postal address, etc.)\nCustomers can contact us by ${companyData?.companyContact}\n`;

      prompt += `What are the most frequently asked questions or problems by our customers?\nHere are the most frequently asked questions from our customers: ${companyData?.companyFaq}\n`;

      prompt += `How would you like me to handle complex customer queries? (redirect to a human agent, provide additional information, etc.)\nWhen it comes to complex customer queries please ${companyData?.complexCustomerQueries}\n`;

      let userInputWithPunctuation = userInput;
      if (!/[\.\?\!]\s*$/.test(userInput)) {
          userInputWithPunctuation += ".";
      }

      prompt += `user: ${userInputWithPunctuation}`;


      const response = await axios({
        method: "post",
        url: "https://api.openai.com/v1/completions",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${OPENAI_API_KEY}`,
        },
        data: {
          prompt,
          temperature: 0.9,
          max_tokens: 150,
          top_p: 1,
          frequency_penalty: 0,
          presence_penalty: 0.6,
          stop: [" Human:", " AI:"],
          model: "text-davinci-003",
        },
      });

      botResponse = response.data.choices[0].text;
      console.log("Bot response:", botResponse);
      
    } catch (error) {
      console.error(error);
    }

    await postMessage({
      chatMessage: userInput,
      sender: currentUserId,
      receiver: domain,
      combineId,
    });
    setUserInput("");
    await postMessage({
      chatMessage: botResponse,
      sender: domain,
      receiver: currentUserId,
      combineId,
    });
} else {
  // L'IA n'est pas activée, envoyez simplement le message à l'agent
  await postMessage({
    chatMessage: userInput,
    sender: currentUserId,
    receiver: domain,
    combineId,
  });
}

setUserInput("");
};

  const handleImageClick = (imageUrl) => {
    setFullscreenImage(imageUrl);
  };

  const handleCloseFullscreenImage = () => {
    setFullscreenImage(null);
  };

  useEffect(() => {
    const fetchAudioMessages = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "chatUsers"));
        const audioMessages = [];
  
        querySnapshot.forEach((doc) => {
          const messages = doc.data().messages;
          if (messages && messages.audioURL) {
            audioMessages.push(messages.audioURL);
          }
        });
  
        setAudioMessages(audioMessages);
      } catch (error) {
        console.error("Error fetching audio messages:", error);
      }
    };
  
    fetchAudioMessages();
  }, []);

  const startRecording = () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          const mediaRecorder = new MediaRecorder(stream);
          setMediaRecorder(mediaRecorder);
  
          const audioChunks = [];
          mediaRecorder.addEventListener("dataavailable", (event) => {
            audioChunks.push(event.data);
          });
          mediaRecorder.addEventListener("stop", () => {
            const audioBlob = new Blob(audioChunks, { type: "audio/webm" });
            const audioURL = URL.createObjectURL(audioBlob);
            setAudioBlob(audioBlob);
            setAudioURL(audioURL);
            setIsPlaying(false); // Réinitialise l'état de lecture
          });
          mediaRecorder.start();
          setRecording(true);
        })
        .catch((error) => {
          console.error("Error accessing microphone:", error);
        });
    }
  };
  

 const playAudio = () => {
    if (audioURL) {
      const audio = new Audio(audioURL);
      audio.play();
      setIsPlaying(true);

      // Add an event listener for when the audio ends
      audio.addEventListener("ended", () => {
        setIsPlaying(false);
      });
    }
  };

  const pauseAudio = () => {
  if (audioURL) {
    const audio = new Audio(audioURL);
    audio.pause();
    setIsPlaying(false);
  }
};

  
  const stopRecording = () => {
    if (mediaRecorder) {
      mediaRecorder.stop();
      setRecording(false);
    }
  };

  const handleAudioSubmit = async () => {
    if (audioBlob) {
      try {
        setIsSending(true);

        const storageRef = ref(storage, "audio/" + Date.now() + ".webm");
        await uploadBytes(storageRef, audioBlob);
        const audioURL = await getDownloadURL(storageRef);
  
        await addDoc(collection(db, "chatUsers", currentUserId, "messages"), {
          messageUserId: domain,
          audioURL: audioURL,
          timestamp: new Date(),
        });
  
        await addDoc(collection(db, "chatUsers", domain, "messages"), {
          messageUserId: domain,
          audioURL: audioURL,
          timestamp: new Date(),
        });
  
        setAudioBlob(null);
        setAudioURL(null);
        setIsSending(false);
        setIsPlaying(false); // Arrête la lecture audio si elle est en cours
      } catch (error) {
        console.log(error);
        setIsSending(false);
      }
    }
  };

  const hasAudioMessages = audioMessages.length > 0;

  
  
  
  return (
    
    <div>

      
      <button className="chatbot-toggle" onClick={handleToggle}>
        {chatbotVisible ? (
          <CloseIcon style={{ width: 35 }} />
        ) : (
          <img style={{ width: 35 }} src={Tchat} alt="Chatbot toggle button" />
        )}
      </button>

      <div
        id="chatbot-container"
        style={{ display: chatbotVisible ? "block" : "none" }}
      >


        <Helmet>
          {gaCodeLoaded && (
            <script
              async
              src={`https://www.googletagmanager.com/gtag/js?id=${gaCode}`}
            ></script>
          )}
          {gaCodeLoaded && (
            <script>
              {`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${gaCode}');
              `}
            </script>
          )}
        </Helmet>




        <div className="chatbot-header">
          <CloseIcon className="chatbot-close" onClick={handleToggle} />
          <a target="_blank" rel="noreferrer" href="https://faceone.fr">
            LUNA
          </a>
        </div>

        <div ref={chatParent} id="chatbot-messages">
        {messages?.map(({ id, messages }) => {
          const isBotMessage = messages.messageUserId === domain;
          const isImageMessage = !!messages.photoURL;
          
        
          return (
            <div
            key={id} // Add a unique key prop here
            className={`message-container ${isBotMessage ? "bot-message" : "user-message"} ${isImageMessage ? "bot-image-message-container" : ""}`}
            >
              {isBotMessage && <img className="bot-img" src={Luna} alt="Bot Profile" />}
              {isImageMessage && (
                <img
                src={messages.photoURL}
                alt="Uploaded"
                className={`chatbot-message-image ${isBotMessage ? "bot-image" : ""}`}
                onClick={() => handleImageClick(messages.photoURL)}
                />
                )}

          
                
              
                {messages.audioURL && (
            <div className={`user-voice-message ${isBotMessage ? "bot-voice-message" : ""}`}>
              <audio src={messages.audioURL} controls style={{ background: 'transparent' }} />
            </div>
          )}


              {messages.message && (
                <div className="message-content">{messages.message}</div>
                )}
            </div>
          );
            
          })}
          
        </div>

        <form id="chatbot-form" onSubmit={handleSubmit}>
          <input
            type="text"
            id="chatbot-input"
            placeholder="Write your message here... 👋"
            value={userInput}
            onChange={(event) => setUserInput(event.target.value)}
          />
          <button type="submit">
            Send your message <SendIcon />{" "}
          </button>


          <div className="chatbot-features" style={{display: 'flex', flexDirection: 'row', gap: '10px', marginTop: '15px'}}>

          {audioURL && (
        <>
          {isPlaying ? (
            <PauseCircleOutlineIcon
              style={{ cursor: "pointer" }}
              onClick={pauseAudio}
              disabled={!audioURL}
            />
          ) : (
            <PlayCircleOutlineIcon
              style={{ cursor: "pointer" }}
              onClick={playAudio}
              disabled={!audioURL}
            />
          )}
        </>
      )}
         


          {recording ? (
            <StopIcon
            onClick={stopRecording}
            style={{ color: "red", cursor: "pointer" }}
            />
            ) : (
              <MicIcon
              onClick={startRecording}
              style={{ color: "#171717", cursor: "pointer" }}
              />
              )}
              </div>

        </form>


        {fullscreenImage && (
          <div
            className="fullscreen-image-overlay"
            onClick={handleCloseFullscreenImage}
          >
            <img
              src={fullscreenImage}
              alt="Fullscreen"
              className="fullscreen-image"
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Chatbot;